import { useState } from "react";
import { useBoltApiClient, IBoltTaskTemplate } from "@bolt/core";
import { AppToasterV2 } from "@ucl/library";
import { createBoltTaskApiClient } from "../../lib/apiClients/boltTaskApiClient";

export enum TaskTemplateSubmitMode {
  CREATE = "create",
  EDIT = "edit",
}

export const useTaskTemplateSubmit = (mode: TaskTemplateSubmitMode) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const boltApiClient = useBoltApiClient();
  const taskApiClient = createBoltTaskApiClient(boltApiClient);

  const submitTaskTemplates = async (
    localTaskTemplates: IBoltTaskTemplate[],
    taskExecutionTypeFields: Record<string, any> | any,
    onSuccess: () //taskTemplate: IBoltTaskTemplate | IBoltTaskTemplate[]
    => Promise<void>
  ) => {
    const parentTask = {
      ...localTaskTemplates[0],
      taskExecutionTypeFields: taskExecutionTypeFields,
    };

    // console.log("submitTaskTemplates", parentTask);

    const isSingleStep = !parentTask.hasMultiSteps;
    setIsSaving(true);

    try {
      if (isSingleStep) {
        const apiCall =
          mode === TaskTemplateSubmitMode.CREATE
            ? taskApiClient.createSingleStepTaskType(parentTask)
            : taskApiClient.updateSingleStepTaskType(parentTask);

        await apiCall.then(onSuccess);
      } else {
        const apiCall =
          mode === TaskTemplateSubmitMode.CREATE
            ? taskApiClient.createMultiStepTaskTypes(localTaskTemplates)
            : taskApiClient.updateMultiStepTaskTypes(localTaskTemplates);

        await apiCall.then(onSuccess);
      }

      const action =
        mode === TaskTemplateSubmitMode.CREATE ? "created" : "updated";
      AppToasterV2.showSuccessAppToaster(
        `Successfully ${action} task template.`
      );
    } catch (error) {
      const action =
        mode === TaskTemplateSubmitMode.CREATE ? "create" : "update";
      AppToasterV2.showFailedActionToaster(
        `Failed to ${action} task templates.`
      );
    } finally {
      setIsSaving(false);
    }
  };

  return { submitTaskTemplates, isSaving };
};
